module.exports = {
    expired_1: "Pautan tamat tempoh",
    limit_time: "Tawaran masa terhad untuk ",
    participate: "Sertai acara ulasan sekarang untuk tuntut ganjaran eksklusif anda!",
    exclusive: "Eksklusif",
    reward: "Ganjaran",
    token: "Token",
    vip: "Hari VIP",
    after_completing: "Selepas melengkapkan ulasan dan pengesahan screenshot, anda akan menerima",
    step_1: "<strong style='color: #000000'>Klik butang di bawah</strong> untuk melawat kedai aplikasi dan <strong style='color: #000000'>tinggalkan ulasan 5 bintang.</strong>",
    step_2: "Selepas melengkapkan ulasan, sila <strong style='color: #000000'>ambil screenshot</strong> kandungan ulasan anda.",
    step_3: "<strong style='color: #000000'>Muat naik screenshot</strong> di bawah dan serahkan ID dalam apl anda untuk menerima ganjaran.",
    click_to: "1. Klik untuk pergi ke ",
    upload: "2. Muat Naik Screenshot Ulasan",
    app_store: "App Store",
    google_play: "Google Play",
    go_to: "Pergi ke ",
    example: "Contoh screenshot",
    upload_screenshot: "Muat Naik Screenshot",
    claim: "Tuntut Ganjaran",
    verification_inprogress: "Terima kasih atas muat naik anda. Screenshot anda sedang disemak secepat mungkin. Sila bersabar.",
    verification_success: "Tahniah! <br/><br/> Anda telah berjaya menuntut ganjaran anda. Ganjaran akan dikreditkan ke akaun anda <strong>dalam masa 24 jam.</strong> Sila tunggu. <br/><br/> Jika anda mempunyai sebarang pertanyaan, jangan hesitate untuk menghubungi sokongan pelanggan.",
    verification_failed: "Screenshot ulasan mesti memenuhi syarat berikut: <br/><br/> <div style='margin-left: 6px'> 1.Penilaian mesti 5 bintang dan kandungan harus positif. <br/><br/> 2.Ulasan mesti dibuat di <strong> Apple App Store atau Google Play Store. </strong> <br/><br/> 3.Screenshot mesti memaparkan kandungan ulasan sepenuhnya, termasuk <strong> avatar, nama pengguna, dan teks ulasan. <strong></div>",
    reupload: "Muat naik semula",
}